
export default {
    name: 'BaseImage',

    props: {
        src: {
            type: String,
            required: true,
        },
        x2: {
            type: String,
            default: '',
        },
        sourceSizes: {
            type: Object,
            default: () => {},
        },
        alt: {
            type: String,
            default: '',
        },
        loading: {
            type: String,
            default: 'lazy',
        },
        fetchpriority: {
            type: String,
            default: null,
        },
    },

    computed: {
        displayedSourceSet() {
            if (this.sourceSizes) {
                return this.x2
                    ? `${this.src} ${this.sourceSizes.x1}, ${this.x2} ${this.sourceSizes.x2}`
                    : this.src
            }
            return this.x2 ? `${this.src} 1x, ${this.x2} 2x` : this.src
        },
    },
}
